<template>
  <div>
    <div class="productTableCom">
      <v-data-table
        :headers="tableHeaders"
        :items="item.items"
        :item-key="item.itemKey"
        :hide-default-header="false"
        hide-default-footer
        class="rounded-lg"
        :items-per-page="-1"
        :no-data-text="$t('common.common_no-history')"
      >
        <template v-slot:[`item.amount`]="{ item: tableItem }">
          {{ formatPrice(Number(tableItem.amount)).toLocaleString() }}
          {{ unitName }}
        </template>
        <template v-slot:[`item.paymentMethodId`]="{ item: tableItem }">
          {{ getPaymentMethod(tableItem.paymentMethodId) }}
        </template>
        <template v-slot:[`item.operationId`]="{ item: tableItem }">
          <NormalButton
            v-if="isOperation && authority.isAdmin"
            :text="item.buttonName"
            height="32px"
            width="120px"
            color="white"
            textColor="thinText--text"
            :outlined="true"
            @click="cancel(tableItem[paymentIdName])"
          />
        </template>
      </v-data-table>
    </div>
    <v-spacer> </v-spacer>
    <div class="pa-5 text-right">
      <!-- フッター -->
      <span class="mr-6">
        {{ $t(item.footers[0].name) }}
        <span class="font-weight-bold">
          {{ formatPrice(item.footers[0].data).toLocaleString() }}
        </span>
        {{ unitName }}
      </span>
      <span class="mr-6">
        {{ $t(item.footers[1].name) }}：
        <span class="font-weight-bold">
          {{ formatPrice(item.footers[1].data).toLocaleString() }}
        </span>
        {{ unitName }}
      </span>
      <span>
        {{ $t(item.footers[2].name) }}：
        <span class="red--text">
          <span class="font-weight-bold">
            {{ formatPrice(item.footers[2].data).toLocaleString() }}
          </span>
          {{ unitName }}
        </span>
      </span>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { paymentMethodUtil, currencyUtil, commonUtil } from '@/util'
import { NormalButton } from '@/components/items'

export default {
  name: 'PaymentTable',

  components: {
    NormalButton
  },
  props: {
    item: {
      type: Object,
      require: true,
      default: () => ({})
    },
    unitName: { default: '' },
    paymentType: { default: '' },
    isOperation: { default: true }
  },
  data: () => ({
    paymentIdName: ''
  }),
  created() {
    this.paymentIdName = this.paymentType + 'PaymentId'
    this.getPaymentMethodListFromApi()
  },
  methods: {
    ...mapActions('PaymentMethod', ['getPaymentMethodListFromApi']),

    getPaymentMethod(id) {
      return paymentMethodUtil.getPaymentMethodName(id)
    },
    cancel(id) {
      this.$emit('cancel', id)
    },
    formatPrice(price) {
      return commonUtil.formatPrice(price)
    }
  },
  computed: {
    ...mapGetters('User', ['authority']),
    tableHeaders() {
      if (!Array.isArray(this.item.headers)) {
        return []
      }
      const headersTmp = this.item.headers.map((header) => {
        if (!this.isOperation) {
          if (header.value === 'operationId') {
            header.text = ''
            header.value = 'noDisplay'
          }
        }
        const tmp = { ...header }
        tmp.text = this.$t(tmp.text)
        return tmp
      })
      return headersTmp
    },
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.productTableCom {
  ::v-deep .v-data-table th {
    background-color: rgba(151, 198, 234, 0.1);
    padding-left: 30px;
  }
  ::v-deep .v-data-table td {
    padding-left: 30px;
  }
}
.normalNumberInput {
  width: 180px;
}
</style>
